<template>
  <page-view title>
    <div slot="headerContent">
      <search-robot @changeRobotId="onChangeRobotId"></search-robot>
    </div>
    <div :style="{ marginBottom: '10px' }">
      <demo-video-alert name="HuiYuanGuanLi"></demo-video-alert>
    </div>
    <exception-page type="norobot" v-if="!currentRobotId" />
    <a-card :bordered="false" v-if="currentRobotId">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="查询条件">
                <a-select v-model="queryParam.search_condition" placeholder="请选择查询条件" allowClear>
                  <a-select-option value="1">微信昵称</a-select-option>
                  <a-select-option value="2">会员ID</a-select-option>
                  <a-select-option value="3">上级ID</a-select-option>
                  <a-select-option value="10">机器人ID</a-select-option>
                  <a-select-option value="9">微信号</a-select-option>
                  <a-select-option value="4">微信ID</a-select-option>
                  <a-select-option value="5">追单号</a-select-option>
                  <a-select-option value="6">省份</a-select-option>
                  <a-select-option value="7">超过多少天未下单</a-select-option>
                  <a-select-option value="8">备注</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="查询内容">
                <a-input v-model="queryParam.keywords" placeholder="请输入查询内容" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="总订单数≥">
                <a-input v-model="queryParam.order_num" placeholder="请输入" />
              </a-form-item>
            </a-col>

            <a-drawer :width="500" title="查询条件" placement="right" :footer-style="{ textAlign: 'right' }"
              :visible="searchDrawerVisible" @close="searchDrawerClose">
              <div class="table-page-search-wrapper">
                <a-form layout="inline">
                  <a-form-item label="查询条件">
                    <a-select v-model="queryParam.search_condition" placeholder="请选择查询条件" allowClear>
                      <a-select-option value="1">微信昵称</a-select-option>
                      <a-select-option value="2">会员ID</a-select-option>
                      <a-select-option value="3">上级ID</a-select-option>
                      <a-select-option value="10">机器人ID</a-select-option>
                      <a-select-option value="9">微信号</a-select-option>
                      <a-select-option value="4">微信ID</a-select-option>
                      <a-select-option value="5">追单号</a-select-option>
                      <a-select-option value="6">省份</a-select-option>
                      <a-select-option value="7">超过多少天未下单</a-select-option>
                      <a-select-option value="8">备注</a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item label="查询内容">
                    <a-input v-model="queryParam.keywords" placeholder="请输入查询内容" />
                  </a-form-item>

                  <a-form-item label="总订单数≥">
                    <a-input v-model="queryParam.order_num" placeholder="请输入" />
                  </a-form-item>

                  <a-form-item label="会员分组">
                    <a-select v-model="queryParam.group_id" placeholder="请选择" allowClear>
                      <a-select-option v-for="(item, index) in currentRobotGroupInfoData" :key="index"
                        :value="item.id">{{ item.name }}</a-select-option>
                    </a-select>
                    <!-- <a-input v-model="queryParam.group_info" placeholder="请输入" /> -->
                  </a-form-item>

                  <a-form-item label="机器人ID">
                    <a-input v-model="queryParam.robot_id" placeholder="请输入" />
                  </a-form-item>
                </a-form>
              </div>
              <template #footer>
                <a-button style="margin-right: 8px" @click="searchDrawerClose">取消</a-button>
                <a-button type="primary" @click="searchDrawerBtn">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
              </template>
            </a-drawer>

            <a-col :md="6" :sm="24">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="searchDrawerShow">高级查询</a-button>
              <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator">
        <!-- <a-button type="primary" :disabled="dieFansData.status" @click="$refs.createInacctive.show(currentRobotId)">创建检测任务</a-button>
        <a-button type="primary" :disabled="dieFansData.status" @click="$refs.delInacctive.show(currentRobotId)">删除僵尸粉</a-button> -->
        <a-button type="primary" @click="$refs.createInacctive.show(currentRobotId)">创建检测任务</a-button>
        <a-button type="primary" @click="$refs.delInacctive.show(currentRobotId)">删除僵尸粉</a-button>
        <!-- <a-button type="primary" @click="delInacitveP">批量删除僵尸粉</a-button> -->
        <a-button type="primary" @click="addInacctive(currentRobotId)">添加僵尸粉</a-button>
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="delInacitveP">批量删除僵尸粉</a-menu-item>
            <!-- <a-button type="primary" @click="delInacitveP">批量删除僵尸粉</a-button> -->
            <a-menu-item key="2" @click="addInacctiveP">批量添加僵尸粉</a-menu-item>
            <!-- <a-button type="primary" @click="addInacctiveP">批量添加僵尸粉</a-button> -->
          </a-menu>
          <a-button>
            批量操作
            <a-icon type="down" />
          </a-button>
        </a-dropdown>
        <!-- <a-button type="primary" @click="addInacctiveP">批量添加僵尸粉</a-button> -->
        <div style="width: 200px; margin-top: -3px">
          <a-progress v-if="dieFansData.conduct" :percent="dieFansData.progress" size="small"
            :format="percent => parseInt(percent) + '%'" />
        </div>
        <!-- <a-popconfirm placement="topLeft" @confirm="handleRefresh">
          <template slot="title">
            <p>您确认要刷新微信好友吗？</p>
          </template>
          
        </a-popconfirm> -->
        <!-- <a-button type="primary">上报黑名单</a-button> -->
        <!-- <a-button type="primary">发送微信消息</a-button> -->
        <!-- <a-button type="primary">修改分组</a-button> -->

        <div style="width: 200px; margin-top: -3px">
          <a-progress v-if="FansRefreshStatus" :percent="FansRefreshStatus['progress']" size="small"
            :format="percent => parseInt(percent) + '%'" />
        </div>
      </div>
      <s-table ref="table" rowKey="uid" :columns="columns" :data="loadData" :alert="options.alert"
        :rowSelection="options.rowSelection" :scroll="{ x: 2400 }" :pagination="{ showQuickJumper: true }">
        <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
        <span slot="avatar" slot-scope="text">
          <a-avatar shape="square" size="small" icon="user" :src="text" />
        </span>
        <span slot="nickname" slot-scope="text">
          <span v-line-clamp="1">{{ text }}</span>
        </span>
        <template slot="balance" slot-scope="text, record">
          <template v-if="record.editable">
            <a-input style="margin: -5px 0" :value="record.editable_data.balance" size="small"
              @change="e => handleChange(e.target.value, record, 'balance')" />
          </template>
          <template v-else>
            <span>{{ text || 0 | currency('￥') }}</span>
          </template>
        </template>

        <template slot="integral" slot-scope="text, record">
          <template v-if="record.editable">
            <a-input style="margin: -5px 0" :value="record.editable_data.integral / 100 || 0" size="small"
              @change="e => handleChange(e.target.value * 100 || 0, record, 'integral')" />
          </template>
          <template v-else>
            <span>{{ text / 100 || 0 | currency('') }}</span>
          </template>
        </template>

        <span slot="wx_id" slot-scope="text">
          <span v-line-clamp="1">{{ text }}</span>
        </span>
        <span slot="username" slot-scope="record">
          <span v-line-clamp="1">{{ record.username.length > 2 ? record.username : '暂无' }}</span>
        </span>
        <span slot="qdlastdt" slot-scope="text">
          <span>{{ text? text: '无签到记录' }}</span>
        </span>
        <span slot="order_date" slot-scope="text">
          <span>{{ text? text: '无下单记录' }}</span>
        </span>
        <template slot="group_info" slot-scope="text, record">
          <template v-if="record.editable">
            <a-select :value="record.editable_data.usertype" style="width: 100%" size="small"
              @change="e => handleChange(e, record, 'usertype')">
              <template v-if="currentRobotGroupInfoData">
                <a-select-option v-for="item in currentRobotGroupInfoData" :value="item.id" :key="item.id">{{
                  item.name
                }}</a-select-option>
              </template>
            </a-select>
          </template>
          <template v-else>
            <a v-if="!text">未设置</a>
            <span v-line-clamp="1" v-else>{{ text }}</span>
          </template>
        </template>
        <template slot="order_sixbit" slot-scope="text, record">
          <template v-if="record.editable">
            <a-input style="margin: -5px 0" :value="record.editable_data.order_sixbit" size="small"
              @change="e => handleChange(e.target.value, record, 'order_sixbit')" />
          </template>
          <template v-else>
            <a v-if="!record.order_sixbit || record.order_sixbit == '0'">无</a>
            <span v-else v-line-clamp="1">{{ record.order_sixbit }}</span>
          </template>
        </template>
        <template slot="sex" slot-scope="record">
          <span v-if="record.sex == '1'">
            <a-tag color="blue">男</a-tag>
          </span>
          <span v-else-if="record.sex == '2'">
            <a-tag color="pink">女</a-tag>
          </span>
          <span v-else>
            <a-tag>未知</a-tag>
          </span>
        </template>
        <template slot="status" slot-scope="text">
          <a-badge v-if="text == 1" color="red" :text="`被拉黑`" />
          <a-badge v-else-if="text == 2" color="red" :text="`被删除`" />
          <a-badge v-else-if="text == 4" color="blue" :text="`已清理`" />
          <a-badge v-else-if="text == 5" color="blue" :text="`待添加`" />
          <a-badge v-else-if="text == 6" color="blue" :text="`已发送请求`" />
          <a-badge v-else color="red" :text="`未知`" />
        </template>
        <template slot="region" slot-scope="record">
          <span v-if="record.address">{{ record.province }} {{ record.address }}</span>
          <span v-else>未知</span>
        </template>
        <template slot="trjid" slot-scope="text, record">
          <template v-if="record.editable">
            <a-input style="margin: -5px 0" :value="record.editable_data.trjid" size="small"
              @change="e => handleChange(e.target.value, record, 'trjid')" />
          </template>
          <template v-else>
            <a v-if="!text || text == '0'">无</a>
            <span v-else v-line-clamp="1">{{ text }}</span>
          </template>
        </template>
        <span slot="avatar" slot-scope="text">
          <a-avatar shape="square" size="small" icon="user" :src="text" />
        </span>
        <template slot="action" slot-scope="text, record">
          <div class="editable-row-operations">
            <span v-if="record.editable">
              <a @click="() => save(record)">保存</a>
              <a-divider type="vertical" />
              <a-popconfirm title="真的放弃编辑吗?" @confirm="() => cancel(record)">
                <a>取消</a>
              </a-popconfirm>
            </span>
            <span v-else>
              <a @click="() => edit(record)">修改</a>
              <a-divider type="vertical" />
              <a @click="$refs.detaildrawer.show(record.sub_id, record.uid)">详情</a>
              <a-divider type="vertical" />
              <a-dropdown>
                <a-menu slot="overlay">
                  <a-menu-item @click="handleAddBlacklist(record)">加入黑名单</a-menu-item>
                  <a-menu-item @click="handleDelGrouplist(record)">删除所在群组</a-menu-item>
                </a-menu>
                <a>
                  更多
                  <a-icon type="down" />
                </a>
              </a-dropdown>
            </span>
          </div>
        </template>
      </s-table>
    </a-card>
    <detail-drawer ref="detaildrawer"></detail-drawer>
    <send-msg-modal ref="sendMsgModal"></send-msg-modal>
    <add-blacklist-modal ref="addBlacklistModal" @ok="$refs.table.refresh()"></add-blacklist-modal>
    <edit-group-modal ref="editGroupModal" @ok="$refs.table.refresh()"></edit-group-modal>
    <del-group-modal ref="delGroupModal" @ok="$refs.table.refresh()"></del-group-modal>
    <CreateInacitveModal ref="createInacctive" />
    <!-- 删除僵尸粉 -->
    <del-inacitve-modal ref="delInacctive" />
    <del-inacitve-modal-p ref="delInacctiveP" />
    <!-- 添加僵尸粉 -->
    <add-inactive-modal v-if="getLoadDataList.length" :loadData="getLoadDataList" ref="addInacctive" />
    <add-inactive-modal-p v-if="getLoadDataList.length" :loadData="getLoadDataList" ref="addInacctiveP" />
  </page-view>
</template>

<script>
import { STable } from '@/components'
import SearchRobot from '@/views/components/SearchRobot'
import FansApi from '@/api/fans'
import { PageView } from '@/layouts'
import { mapActions, mapGetters } from 'vuex'
import { ExceptionPage } from '@/components'
import DetailDrawer from '@/views/fans/detail/drawer'
import SendMsgModal from './modules/SendMsgModal'
import EditGroupModal from './modules/EditGroupModal'
import CreateInacitveModal from './modules/CreateInacitveModal'
// 删除僵尸粉
import DelInacitveModal from './modules/DelInactiveModal'
import DelInacitveModalP from './modules/DelInactiveModalP'
// 添加僵尸粉
import AddInactiveModal from './modules/AddInactiveModal'
import AddInactiveModalP from './modules/AddInactiveModalP.vue'
import AddBlacklistModal from './modules/AddBlacklistModal'
import DelGroupModal from './modules/DelGroupModal'
import DemoVideoAlert from '@/views/components/DemoVideoAlert'
import { constantRouterMap } from '@/config/router.config'
export default {
  name: 'FansList',
  components: {
    PageView,
    STable,
    SearchRobot,
    ExceptionPage,
    DetailDrawer,
    SendMsgModal,
    AddBlacklistModal,
    EditGroupModal,
    DelGroupModal,
    DemoVideoAlert,
    CreateInacitveModal,
    DelInacitveModal,
    DelInacitveModalP,
    AddInactiveModal,
    AddInactiveModalP,
  },
  data() {
    return {
      currentRobotId: null,
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '机器人ID',
          width: 100,
          dataIndex: 'sub_id',
        },
        {
          title: 'UID',
          width: 80,
          dataIndex: 'uid',
          sorter: true,
        },
        {
          title: '头像',
          dataIndex: 'avatar',
          width: 80,
          scopedSlots: { customRender: 'avatar' },
        },
        {
          title: '微信昵称',
          dataIndex: 'nickname',
          width: 200,
          scopedSlots: { customRender: 'nickname' },
        },
        {
          title: '微信号',
          width: 200,
          scopedSlots: { customRender: 'username' },
        },
        {
          title: '微信ID',
          width: 200,
          dataIndex: 'wxid',
          scopedSlots: { customRender: 'wx_id' },
        },
        {
          title: '好友状态',
          width: 150,
          dataIndex: 'del',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '性别',
          width: 100,
          scopedSlots: { customRender: 'sex' },
        },
        {
          title: '地区',
          width: 200,
          scopedSlots: { customRender: 'region' },
        },
        {
          title: '余额',
          sorter: true,
          width: 100,
          dataIndex: 'balance',
          scopedSlots: { customRender: 'balance' },
        },
        {
          title: '积分',
          sorter: true,
          width: 100,
          dataIndex: 'integral',
          scopedSlots: { customRender: 'integral' },
        },
        {
          title: '订单数',
          sorter: true,
          width: 100,
          dataIndex: 'order_num',
        },
        {
          title: '分组类型',
          dataIndex: 'user_group_info.name',
          width: 150,
          scopedSlots: { customRender: 'group_info' },
        },
        {
          title: '上级ID',
          dataIndex: 'trjid',
          width: 100,
          scopedSlots: { customRender: 'trjid' },
        },
        {
          title: '追单号',
          width: 100,
          scopedSlots: { customRender: 'order_sixbit' },
        },
        {
          title: '最后签到时间',
          dataIndex: 'qdlastdt',
          width: 150,
          sorter: true,
          scopedSlots: { customRender: 'qdlastdt' },
        },
        {
          title: '最后下单时间',
          dataIndex: 'order_date',
          width: 150,
          sorter: true,
          scopedSlots: { customRender: 'order_date' },
        },
        {
          title: '创建时间',
          dataIndex: 'regtime',
          width: 200,
          sorter: true,
        },
        // {
        //   title: '操作',
        //   width: '175px',
        //   fixed: 'right',
        //   scopedSlots: { customRender: 'action' }
        // }
      ],

      selectedRowKeys: [],
      selectedRows: [], // 选中的这一行的内容
      // 分组数据
      groupInfoData: {},
      // custom table alert & rowSelection
      options: {
        alert: {
          show: true,
          clear: () => {
            this.selectedRowKeys = []
          },
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange,
        },
      },
      wxidList: [],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return FansApi.getDieFansList(
          Object.assign(parameter, this.queryParam, {
            sub_id: this.currentRobotId,
            sortOrder: 'ascend' // 加这个参数，后台会把res.data按照UID升序
          })
        ).then(res => {
          res.data.forEach(val => {
            val.editable = false
            val.editable_data = {}
          })
          this.getLoadDataList = res.data
          return res
        })
      },
      getLoadDataList: [], // 接收一下loadData
      searchDrawerVisible: false, // 是否可见
    }
  },
  computed: {
    dieFansData() {
      const taobaoStatus = this.$store.state.order.taobaoStatus
      return taobaoStatus[this.currentRobotId] ? taobaoStatus[this.currentRobotId] : {}
    },
    currentRobotGroupInfoData() {
      const currentRobotId = this.currentRobotId
      const groupInfoData = this.groupInfoData
      return groupInfoData[currentRobotId]
    },
    FansRefreshStatus() {
      const robotid = this.currentRobotId
      const fun = this.getRobotFansRefreshStatusById()
      const data = fun(robotid)
      if (data && data['conduct']) {
        return data
      } else {
        return false
      }
    },
  },
  methods: {
    ...mapActions(['WEBSOCKER_ACTIONS_SENDROBOTMSG', 'demoSetVideo']),
    ...mapGetters(['getRobotFansRefreshStatusById']),
    onChangeRobotId(id) {
      this.currentRobotId = id
      if (this.$refs.table) {
        this.$refs.table.refresh(true)
      }
      // 获取分组
      FansApi.getGroupList({ sub_id: id }).then(res => {
        this.groupInfoData[id] = res.data
      })
    },
    // 会员详情
    handleFansDetail(id) {
      this.$router.push({ path: `/fans/detail/${this.currentRobotId}/${id}` })
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: true,
            clear: () => {
              this.selectedRowKeys = []
            },
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange,
          },
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null,
        }
        this.optionAlertShow = false
      }
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    handleDelete(id) {
      this.$refs.table.refresh()
    },
    edit(row) {
      row.editable = true
      row.editable_data = {
        balance: row.balance,
        usertype: row.usertype,
        trjid: row.trjid,
        integral: row.integral,
        order_sixbit: row.order_sixbit,
      }
    },
    handleChange(value, record, key) {
      record.editable_data[key] = value
    },
    save(row) {
      const balance = row.editable_data.balance
      const usertype = row.editable_data.usertype
      const trjid = row.editable_data.trjid
      const integral = row.editable_data.integral
      const order_sixbit = row.editable_data.order_sixbit
      const group_info = this.currentRobotGroupInfoData.filter(item => {
        if (item.id == usertype) return item
      })[0]
      row.user_group_info = group_info
      row.balance = balance
      row.usertype = usertype
      row.trjid = trjid
      row.integral = integral
      row.order_sixbit = order_sixbit
      // console.log(row)
      const params = {
        sub_id: row.sub_id,
        uid: row.uid,
        balance: row.balance,
        integral: row.integral / 100,
        usertype: row.usertype,
        trjid: row.trjid,
        order_sixbit: row.order_sixbit,
      }
      FansApi.updateFensInfo(params).then(res => {
        if (res.code === 1) {
          this.$message.success('保存成功')
        } else {
          this.$message.error(res.msg)
        }
      })
      row.editable = false
    },
    cancel(row) {
      row.editable = false
      row.editable_data = {
        balance: row.balance,
        usertype: row.usertype,
        trjid: row.trjid,
      }
    },
    handleSendMsg() {
      const wxids = this.selectedRows.map(item => {
        return item.wxid
      })
      this.$refs.sendMsgModal.show({ robotid: this.currentRobotId, wxids: wxids })
    },
    delInacitveP() {
      const wxids = this.selectedRows.map(item => {
        return item.wxid
      })
      const robotid = this.currentRobotId
      this.$refs.delInacctiveP.show({ robotid: robotid, wxids: wxids })
    },
    // 添加僵尸粉
    addInacctive(currentRobotId) {
      this.$refs.addInacctive.show(currentRobotId)

    },
    // 批量添加僵尸粉
    addInacctiveP() {
      // console.log('批量添加僵尸粉');
      const wxids = this.selectedRows.map(item => {
        return item.wxid
      })
      const robotid = this.currentRobotId
      this.$refs.addInacctiveP.show({ robotid: robotid, wxids: wxids })
    },
    handleEditGroup() {
      const uids = this.selectedRows.map(item => {
        return item.uid
      })
      this.$refs.editGroupModal.show({ robotid: this.currentRobotId, uids: uids })
    },
    handleSendMsgByWxid(wxid) {
      this.$refs.sendMsgModal.show({ robotid: this.currentRobotId, wxids: [wxid] })
    },
    handleRefresh() {
      this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
        robotid: this.currentRobotId,
        type: 'refreshlist',
        data: {},
      }).then(result => {
        this.$message.success('发送指令成功')
      })
    },
    handleFansReg() {
      const that = this
      this.$confirm({
        title: '申请添加好友',
        content: '确定要向选中的会员发起添加好友申请',
        onOk() {
          const wxids = that.selectedRows.map(item => {
            return item.wxid
          })
          that
            .WEBSOCKER_ACTIONS_SENDROBOTMSG({
              robotid: that.currentRobotId,
              type: 'RequestFansReg',
              data: {
                wxids,
              },
            })
            .then(result => {
              that.$message.success('发送指令成功')
            })
        },
        onCancel() { },
      })
    },
    handleAddBlacklist(data) {
      this.$refs.addBlacklistModal.show(this.currentRobotId, data)
    },
    handleDelGrouplist(data) {
      // console.log(data.uid, data.sub_id)
      this.$refs.delGroupModal.show(data)
    },
    // 关闭抽屉
    searchDrawerClose() {
      this.searchDrawerVisible = false
    },
    // 展示抽屉
    searchDrawerShow() {
      this.searchDrawerVisible = true
    },
    // 查询按钮
    searchDrawerBtn() {
      // console.log('点击抽屉的查询')
      this.$refs.table.refresh(true)
      this.searchDrawerVisible = false
    },
  },
}
</script>
<style lang="less" scoped>
.table-operator {
  display: flex;
  flex-direction: row;
  align-items: center;
}

/deep/ .page-header {
  .extra {
    display: none;
  }

  .headerContent {
    flex: 0 1 100% !important;
  }
}
</style>
